module.exports = __webpack_public_path__ + "img/8_deal_architech.3c5c5e48.png";